if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.enableMagnifier();
      }

      hide() {
        this.removeMagnifier();
        super.hide();
      }

      enableMagnifier() {
        this.querySelectorAll('.product-media-modal__content > img').forEach((image) => {
          if (image.dataset.magnifierBound) return;
          image.dataset.magnifierBound = 'true';
          // the media-modal base class closes on any mouse pointerup; keep
          // image clicks for the magnifier (background still closes)
          image.addEventListener('pointerup', (event) => event.stopPropagation());
          image.addEventListener('click', (event) => {
            event.preventDefault();
            this.openMagnifier(image, event);
          });
        });
      }

      removeMagnifier() {
        this.querySelectorAll('.product-media-modal__magnifier').forEach((lens) => lens.remove());
      }

      openMagnifier(image, event, zoomRatio = 2) {
        this.removeMagnifier();
        const lens = document.createElement('div');
        lens.className = 'product-media-modal__magnifier';
        lens.setAttribute('aria-hidden', 'true');
        const rect = image.getBoundingClientRect();
        lens.style.top = `${rect.top}px`;
        lens.style.left = `${rect.left}px`;
        lens.style.width = `${rect.width}px`;
        lens.style.height = `${rect.height}px`;
        lens.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
        lens.style.backgroundSize = `${rect.width * zoomRatio}px auto`;

        const pan = (pointer) => {
          const x = Math.min(Math.max(pointer.clientX - rect.left, 0), rect.width);
          const y = Math.min(Math.max(pointer.clientY - rect.top, 0), rect.height);
          lens.style.backgroundPosition = `${(x / rect.width) * 100}% ${(y / rect.height) * 100}%`;
        };
        pan(event);
        lens.addEventListener('pointermove', pan);
        lens.addEventListener('pointerup', (e) => e.stopPropagation());
        lens.addEventListener('click', () => lens.remove());
        lens.addEventListener('mouseleave', () => lens.remove());
        this.querySelector('.product-media-modal__dialog').appendChild(lens);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
